import React from "react";

export default function IconBadge({ children, className = "", ...props }) {
  return (
    <span className={`icon-badge ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}